import { render, staticRenderFns } from "./ExportBox.vue?vue&type=template&id=3805085b&scoped=true"
import script from "./ExportBox.vue?vue&type=script&lang=js"
export * from "./ExportBox.vue?vue&type=script&lang=js"
import style0 from "./ExportBox.vue?vue&type=style&index=0&id=3805085b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3805085b",
  null
  
)

export default component.exports